export function removeYearData(xaxis) {
  return xaxis.map((timestamp) => {
    if (timestamp.split(' ')[0] === 'Jan') return timestamp;
    return timestamp.split(' ')[0];
  });
}
